import { render, staticRenderFns } from "./ServiceContractsOverview.vue?vue&type=template&id=209a130d"
import script from "./ServiceContractsOverview.vue?vue&type=script&lang=js"
export * from "./ServiceContractsOverview.vue?vue&type=script&lang=js"
import style0 from "./ServiceContractsOverview.vue?vue&type=style&index=0&id=209a130d&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports